import { PromptModelTestCase as PromptModelTestCaseResponse } from '~/api/sylvanus/typedefs.autogen';
import { PromptModelTestCase } from '~/features/x-ray/types/deprecated';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { mapTestCase } from './transformers';

export interface CreatePromptModelTestCaseParams {
  modelId: Uuid;
  version: number;
  highlightMethod: string;
  triggerExecution?: boolean;
}

type Response = PromptModelTestCaseResponse | PromptModelTestCase;

export const createPromptModelTestCase = async ({
  highlightMethod,
  modelId,
  version,
  triggerExecution,
}: CreatePromptModelTestCaseParams): Promise<Response> => {
  const response = (await sylvanus.post(
    `/model/${modelId}/version/${version}/testcase`,
    {},
    {
      params: {
        trigger_execution: triggerExecution,
      },
    },
  )) as PromptModelTestCaseResponse;

  return mapTestCase(response, highlightMethod);
};
